import type { IconSvgObject } from './types';

const DatabaseImportIcon: IconSvgObject = [
  ["ellipse", { cx: "12", cy: "5", rx: "8", ry: "3", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 10.8418C7.60158 11.0226 8.27434 11.1716 9 11.2817", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 15C7.58172 15 4 13.6569 4 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M7 17.8418C7.60158 18.0226 8.27434 18.1716 9 18.2817", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 22C7.58172 22 4 20.6569 4 19V5M20 5V12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M20 19.3265L18.8258 20.8131C18.2008 21.6044 17.8883 22 17.5 22C17.1117 22 16.7992 21.6044 16.1742 20.8131L15 19.3265M17.5 21.9128V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default DatabaseImportIcon;
